import { UrlObject } from 'url';
import Logo from '@/creditflowresearch/ui/common/components/molecules/Logo';
import HamburgerButton from '@creditflowresearch/uilib/HamburgerButton';

interface IMobileLogoProps {
  isMenuOpen: boolean,
  onMenuToggle: () => void,
  url?: string | UrlObject | null,
  dataTest?: string,
}

const MobileLogo = ({ isMenuOpen, onMenuToggle, dataTest = 'mobileLogo', url }: IMobileLogoProps) => (
  <Logo
    url={ url }
    hamburgerToggle={ <HamburgerButton isOpen={ isMenuOpen } onClick={ onMenuToggle } dataTest="mobileHamburgerButton" /> }
    dataTest={ dataTest }
  />
);

export default MobileLogo;
